export const noty = {
  done: 'Data changed successfully',
  error: 'Something went wrong',
  link_copied: 'Link copied',
  text_copied: 'Copied',
  export_started:
    'We prepare statistics detailing for you. You will receive a notification with a download link when the file is available.',
  export_pbx:
    'We are preparing an archive of records for you. You will receive a notification with a download link when the file is available.'
};
